import * as yup from 'yup';

const cpfRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;

export const residentValidationSchema = yup.object({
  name: yup
    .string()
    .required('O nome é obrigatório')
    .min(3, 'O nome deve ter pelo menos 3 caracteres'),
  email: yup
    .string()
    .email('E-mail inválido')
    .required('O e-mail é obrigatório'),
  documentNumber: yup
    .string()
    .matches(cpfRegex, 'CPF deve estar no formato 000.000.000-00')
    .optional(),
  birth_date: yup
    .string()
    .optional(),
  phoneNumber: yup
    .string()
    .optional(),
  gender_flag: yup
    .string()
    .oneOf(['MALE', 'FEMALE'], 'Gênero inválido')
    .optional(),
  marital_flag: yup
    .string()
    .optional(),
  status: yup
    .string()
    .required('O status é obrigatório'),
  nationality: yup.string(),
  cnh_number: yup.string(),
  cnh_expiration: yup.string(),
  unit: yup
    .string()
    .optional(),
});